import { defineMessages } from 'react-intl'

export const homeConfigurationMessages = defineMessages({
  configFilesTableTitle: {
    id: 'homeConfiguration.configFilesTableTitle',
    description: 'Home Config Files table title on configuration page',
    defaultMessage: 'Home Config Files',
  },
  successTitle: {
    id: 'homeConfiguration.successTitle',
    description: 'Title of upload modal',
    defaultMessage: 'Success',
  },
  successMessage: {
    id: 'homeConfiguration.successMessage',
    description: 'Upload success message',
    defaultMessage: 'Successfully uploaded.',
  },
  uploadNonMatch: {
    id: 'homeConfiguration.uploadNonMatch',
    description: 'Upload message for non-matching Home UID',
    defaultMessage:
      'This config file has non-matching Home UID. It will appear in Job Info Non-matching config list',
  },
  uploadDoneButton: {
    id: 'homeConfiguration.uploadDoneButton',
    description: 'Done button for upload modal',
    defaultMessage: 'Done',
  },
  dropzoneTitle: {
    id: 'homeConfiguration.dropzoneTitle',
    description:
      'Title in modal showing that user is uploading a host config file',
    defaultMessage: 'Upload Config File',
  },
  deployButton: {
    id: 'homeConfiguration.deployButton',
    description: 'Deploy button - for config files table',
    defaultMessage: 'Deploy',
  },
  redeploy: {
    id: 'homeConfiguration.redeploy',
    description: 'Redeploy button - for config files table',
    defaultMessage: 'Redeploy',
  },
  deleteButton: {
    id: 'homeConfiguration.deleteButton',
    description: 'Delete button - for config files table',
    defaultMessage: 'Delete',
  },
  deployTitle: {
    id: 'homeConfiguration.deployTitle',
    description: 'Title for deploying files',
    defaultMessage: 'Deploy config file',
  },
  deployBody: {
    id: 'homeConfiguration.deployBody',
    description: 'Modal text for successful deploying a config file to host',
    defaultMessage: 'Config was successfully deployed to the host.',
  },
  deleteFileTitle: {
    id: 'homeConfiguration.deleteFileTitle',
    description:
      'Title for modal that confirms deleting a home/host config file',
    defaultMessage: 'Delete config file?',
  },
  deleteConfirmText: {
    id: 'homeConfiguration.deleteConfirmText',
    description: 'Confirmation for deleting files',
    defaultMessage:
      '{configName} will be permanently deleted from Savant Central Management. {br} This action cannot be undone.',
  },
  headerName: {
    id: 'homeConfiguration.headerName',
    description: "Table header for config's Name",
    defaultMessage: 'Name',
  },
  headerUploaded: {
    id: 'homeConfiguration.headerUploaded',
    description: "Table header for config's Uploaded date",
    defaultMessage: 'Uploaded',
  },
  deploying: {
    id: 'homeConfiguration.deploying',
    description: 'Deploying progress label',
    defaultMessage: 'Deploying...',
  },
  dateDeployed: {
    id: 'homeConfiguration.dateDeployed',
    description: 'Date Deployed label for Mobile Deployment History',
    defaultMessage: 'Date Deployed',
  },
})

export const noMonitoringAccessMessages = defineMessages({
  noMonitoringAccesTitle: {
    id: 'noMonitoringAccess.noMonitoringAccesTitle',
    description: 'No monitoring access title',
    defaultMessage: 'You don’t have monitoring access',
  },
  noMonitoringAccessData: {
    id: 'noMonitoringAccess.noMonitoringAccessData',
    description: 'No monitoring access home data',
    defaultMessage: 'No home data found',
  },
})

export const homeActiveConfigurationMessages = defineMessages({
  created: {
    id: 'homeActiveConfiguration.created',
    description: 'Title "Created" for table of Active Configuration Section',
    defaultMessage: 'Created',
  },
  updated: {
    id: 'homeActiveConfiguration.updated',
    description: 'Title "Updated" for table of Active Configuration Section',
    defaultMessage: 'Updated',
  },
  name: {
    id: 'homeActiveConfiguration.name',
    description: 'Title "Name" for table of Active Configuration Section',
    defaultMessage: 'Name',
  },
  activeHeader: {
    id: 'homeActiveConfiguration.activeHeader',
    description: 'Header for table of Active Configuration Section',
    defaultMessage: 'Active Configuration',
  },
  lastActiveHeader: {
    id: 'homeActiveConfiguration.lastActiveHeader',
    description: 'Header for table of Last Active Configuration Section',
    defaultMessage: 'Last Active Configuration',
  },
  noConfig: {
    id: 'homeActiveConfiguration.noConfig',
    description: 'Table message for no active config',
    defaultMessage: 'There is no active configuration running on this system.',
  },
})

export const homeConfigFilesMessages = defineMessages({
  matching: {
    id: 'homeConfigFilesMessages.matching',
    description:
      'Filter label for home configurations that match this current host',
    defaultMessage: 'Matching Home UID',
  },
  notMatching: {
    id: 'homeConfigFilesMessages.notMatching',
    description:
      'Filter label for home configurations that not match this current host',
    defaultMessage: 'Non-matching',
  },
  uploadFile: {
    id: 'homeConfigFilesMessages.uploadFile',
    description: 'Button text for uploading a home configuration',
    defaultMessage: 'Upload File',
  },
  noUploaded: {
    id: 'homeConfigFilesMessages.noUploaded',
    description:
      'Information message that no configuration files were uploaded for this home',
    defaultMessage: 'No configuration files uploaded',
  },
})
